import { NavigationItem } from "../types";

export const navigationItems: NavigationItem[] = [
  {
    id: "dashboard",
    label: "Dashboard",
    icon: "dashboard",
    path: "/dashboard"
  },
  {
    id: "forecasting",
    label: "Forecasting",
    icon: "trending",
    path: "/forecasting"
  },
  {
    id: "whats-on-site",
    label: "What's on Site",
    icon: "plant",
    path: "/whats-on-site"
  },
  {
    id: "whos-on-site",
    label: "Who's on Site",
    icon: "worker",
    path: "/whos-on-site"
  },
  {
    id: "documents",
    label: "Document Library",
    icon: "file",
    path: "/documents"
  },
  {
    id: "approvals",
    label: "Approvals",
    icon: "approval",
    path: "/approvals"
  }
];

export const bottomNavigationItems: NavigationItem[] = [
  {
    id: "project-team",
    label: "Project Team",
    icon: "team",
    path: "/project-team"
  }
];
